import styled from 'styled-components'

const StyledPaymentMethod = styled.div`
  margin-bottom: 40px;

  .billing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    font-family: ${({ theme }) => theme.fonts.lexend};

    .billing-subheader {
      color: ${({ theme }) => theme.colors.gray[700]};
      font-size: 20px;
      line-height: 32px;
      font-weight: 400;
    }

    .billing-button {
      color: ${({ theme }) => theme.colors.green[300]};
      font-size: 14px;
      letter-spacing: 1px;
      border: 0;
      background: transparent;
      text-transform: uppercase;
      font-weight: 400;
    }
  }

  .payment-method-empty-state {
    font-family: ${({ theme }) => theme.fonts.nunito};
    padding: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: rgba(235, 235, 235, 0.5);
    border: 1px solid #ebebeb;

    display: grid;
    justify-content: center;
    grid-gap: 1rem;
    font-weight: 500;
    place-content: center;
    place-items: center;
  }

  .payment-method-container {
    font-family: ${({ theme }) => theme.fonts.nunito};
    padding: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: rgba(235, 235, 235, 0.5);
    border: 1px solid #ebebeb;

    .payment-method-card {
      display: flex;
      align-items: center;
      font-weight: 500;
      width: 100%;
      justify-content: space-between;
      max-width: 550px;
      text-transform: capitalize;

      .card-expiry {
        margin-right: 1rem;
      }

      .card-logo {
        height: 28px;
        width: 28px;
        position: relative;
        margin-right: 1rem;
      }

      img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .subscription-payment-info {
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #9e9e9e;
      margin-top: 27px;

      .subscription-renew {
        color: black;
      }
    }
  }
`

export default StyledPaymentMethod
